"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormRemoveStatement = void 0;
const createFormRemoveStatement = (createPropertyName, isIllegalWord) => (property, expressionAttributeNames) => {
  if (isIllegalWord(property)) {
    const propertyName = createPropertyName(property, expressionAttributeNames);
    return `#${propertyName}`;
  }
  return property;
};
exports.createFormRemoveStatement = createFormRemoveStatement;